import './Index.css';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Headroom from "headroom.js";
import {
  Button,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

import FSKLogo from "assets/img/brand/FSK.svg";
import { formatInitialsName } from "../../../utils/views/pages/InitialsFormat.js"
import secureLocalStorage from "react-secure-storage";
import { useUserImage } from "../../../views/pages/LandingPage/Context/UserImageContext";
import { logout, getAccountApps } from "../../../network/ApiAxios";

const StoreNavbar = () => {
  const [hasApps, setHasApps] = useState(false);
  const [user, setUser] = useState(JSON.parse(secureLocalStorage.getItem("user")));
  const initials = user ? formatInitialsName(user.name) : "";
  const navigate = useNavigate();
  const { imageContent, refreshImage, clearCache } = useUserImage();

  useEffect(() => {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    headroom.init();

    if (user?.image) {
      refreshImage(user.image);
    }

    // Verificar se o usuário tem apps
    const checkUserApps = async () => {
      if (user?.account) {
        try {
          let params = {
            filter: {
              account: user.account
            }
          }
          const response = await getAccountApps(params);
          const { data } = response;
          
          if (data.success && data.account.apps && data.account.apps.length > 0) {
            setHasApps(true);
          } else {
            setHasApps(false);
          }
        } catch (error) {
          console.error("Error:", error);
          setHasApps(false);
        }
      }
    };

    checkUserApps();
  }, [user]);

  const tryLogOut = async () => {
    const token = secureLocalStorage.getItem("token");

    try {
      const response = await logout(token);
      const { data } = response;
      console.log("DATA:", data)
    } catch (error) {
      console.error("Erro no logout:", error);
    }

    clearCache();
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("user");
    secureLocalStorage.removeItem("app");
    
    setUser(null);
    navigate("/home");
  }

  const handleLogOut = (e) => {
    e.preventDefault();
    tryLogOut();
  }

  const handleProfileClick = (e) => {
    if (!hasApps) {
      e.preventDefault();
      alert("You need to add an app before accessing your profile. Please go to the store and add a license first.");
    }
  }

  return (
    <>
      <header className="header-global">
        <Navbar
          className="navbar-main navbar-transparent navbar-light headroom"
          expand="lg"
          id="navbar-main"
        >
          <Container 
            id="navbar-store" 
            className="px-3 d-flex justify-content-between align-items-center"
          >

            <NavbarBrand 
              to="/" 
              tag={Link} 
              className="me-auto flex-shrink-0 p-0"
              style={{ maxWidth: '120px' }}
            >
              <img 
                src={FSKLogo} 
                alt="Logo FSK" 
                className="img-fluid"
              />
            </NavbarBrand>

            <button className="navbar-toggler" id="navbar_global">
              <i className="fas fa-bars"></i>
            </button>

            <UncontrolledCollapse
              toggler="#navbar_global"
              navbar
            >

              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    <Link to="/">
                      <img src={FSKLogo} alt="Logo FSK" className="img-fluid w-50"/>
                    </Link>
                  </Col>
                  <Col className="collapse-close" xs="6">
                    <button className="navbar-toggler" id="navbar_global">
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>

                {user && (
                  <Row className="mt-3 mb-2">
                    <Col xs="12">
                      <div className="d-flex align-items-center px-3 py-2">
                        {imageContent ? (
                          <img
                            alt="User profile"
                            src={imageContent}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                          />
                        ) : (
                          <div 
                            className="user-initials" 
                            style={{
                              width: '40px',
                              height: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '50%'
                            }}
                          >
                            {initials}
                          </div>
                        )}
                        <div className="ml-3">
                          <div className="font-weight-bold text-dark">{user.name}</div>
                          <small className="text-muted">{user.email}</small>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>

              <Nav className="navbar-nav-hover align-items-lg-center nav-options ml-4" navbar>

                <Link to="/">
                  <span className="nav-link-inner--text">Home</span>
                </Link>

                <UncontrolledDropdown nav>
                  <DropdownToggle nav>
                    <span className="nav-link-inner--text mx-0">Educational Products</span>
                  </DropdownToggle>

                  <DropdownMenu className="dropdown-menu-xl">
                    <div className="dropdown-menu-inner">

                      <Media
                        className="d-flex align-items-center"
                        href="/listen-first"
                      >
                        <Media body className="ml-3">
                          <h6 className="heading text-primary mb-md-1">
                            Listen First
                          </h6>
                        </Media>
                      </Media>

                      <Media
                        className="d-flex align-items-center"
                        href="/elcar"
                      >
                        <Media body className="ml-3">
                          <h6 className="heading text-primary mb-md-1">
                            ELCAR (Coming soon)
                          </h6>
                        </Media>
                      </Media>

                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <Link to="/admin">
                  <span className="nav-link-inner--text">Central System</span>
                </Link>

              </Nav>

              {user && (
                <Nav className="d-lg-none mt-5 px-3" navbar>
                  <div className="d-flex w-100 gap-2">
                    <NavItem className="flex-fill">
                      <NavLink 
                        to={hasApps ? "/admin/user-profile" : "#"}
                        tag={hasApps ? Link : "a"}
                        onClick={handleProfileClick}
                        className="text-center py-2 mr-2 border rounded-pill"
                        style={{
                          display: 'block',
                          backgroundColor: '#f7f8f9',
                          opacity: hasApps ? 1 : 0.5,
                          cursor: hasApps ? 'pointer' : 'not-allowed'
                        }}
                      >
                        <i className="ni ni-single-02 d-block mb-1" />
                        <small>My profile</small>
                      </NavLink>
                    </NavItem>
                    <NavItem className="flex-fill">
                      <NavLink 
                        href="#logout" 
                        onClick={handleLogOut} 
                        className="text-center py-2 ml-2 border rounded-pill"
                        style={{
                          display: 'block',
                          backgroundColor: '#f7f8f9'
                        }}
                      >
                        <i className="ni ni-user-run d-block mb-1" />
                        <small>Logout</small>
                      </NavLink>
                    </NavItem>

                  </div>
                  
                </Nav>
              )}

              {!user && (
                <Nav className="d-lg-none mt-3" navbar>
                  <NavItem className="w-100">
                    <NavLink href="/auth/login" className="px-3">
                      <i className="ni ni-circle-08 mr-2" />
                      <span>Sign In</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              )}

              <Nav className="align-items-lg-center ml-lg-auto d-none d-lg-flex" navbar>

                <NavItem>

                  {user ? (
                    <UncontrolledDropdown nav>
                      <DropdownToggle nav className="nav-link-icon py-0">
                        {imageContent ? (
                          <img
                            alt="User profile"
                            className="avatar-180__img"
                            src={imageContent}
                            style={{
                              width: '35px',
                              height: '35px',
                              borderRadius: '50%',
                              objectFit: 'cover',
                              cursor: 'pointer'
                            }}
                          />
                        ) : (
                          <div className="user-initials py-0" style={{ cursor: 'pointer' }}>
                            {initials}
                          </div>
                        )}
                      </DropdownToggle>
                      
                      <DropdownMenu className="dropdown-menu-arrow" right>
                        <DropdownItem className="noti-title" header tag="div">
                          <h6 className="text-overflow m-0">Welcome!</h6>
                        </DropdownItem>
                        
                        <DropdownItem 
                          to={hasApps ? "/admin/user-profile" : "#"}
                          tag={hasApps ? Link : "a"}
                          onClick={handleProfileClick}
                          style={{
                            opacity: hasApps ? 1 : 0.5,
                            cursor: hasApps ? 'pointer' : 'not-allowed'
                          }}
                        >
                          <i className="ni ni-single-02" />
                          <span>My profile</span>
                        </DropdownItem>
                        
                        <DropdownItem divider />
                        
                        <DropdownItem href="#logout" onClick={handleLogOut}>
                          <i className="ni ni-user-run" />
                          <span>Logout</span>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  ) : (

                    <NavLink
                      className="nav-link-icon"
                      href="/auth/login"
                      id="tooltip112445449"
                      target="_self"
                    >
                      <i className="ni ni-circle-08" />
                      <span className="nav-link-inner--text ml-2">
                        Sign In
                      </span> 
                    </NavLink>
                  )}

                </NavItem>

              </Nav>

            </UncontrolledCollapse>

          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default StoreNavbar;